import { render, staticRenderFns } from "./crowdMarketing.vue?vue&type=template&id=8b2a6aee&scoped=true&"
import script from "./crowdMarketing.vue?vue&type=script&lang=js&"
export * from "./crowdMarketing.vue?vue&type=script&lang=js&"
import style0 from "./crowdMarketing.vue?vue&type=style&index=0&id=8b2a6aee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a6aee",
  null
  
)

export default component.exports